export enum AttributStage {
  AvecRemuneration = 'AVEC_REMUNERATION',
  SansRemuneration = 'SANS_REMUNERATION',
  AvecOuSansRemuneration = 'AVEC_OU_SANS_REMUNERATION',
}
